function HeroComponent({ title }: { title: string }) {
	return (
		<section
			id="hero"
			className="flex items-center justify-center bg-secondary py-32"
		>
			<h1 className="text-center text-3xl font-bold lg:text-5xl">{title}</h1>
		</section>
	)
}

export default HeroComponent
